<script lang="ts">
  import { t } from '../lib/i18n'

  let { title, onMine }: { title: string; onMine?: () => void } = $props()
</script>

<header class="g-header">
  <div class="g-brand">
    <img src="/favicon.svg" alt="" width="28" height="28" />
    <span>{title}</span>
  </div>
  {#if onMine}
    <button type="button" class="g-icon-button" aria-label={t('done.myUploads')} onclick={onMine}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="3" /><circle cx="9" cy="9" r="2" /><path d="m21 15-5-5L5 21" />
      </svg>
    </button>
  {/if}
</header>
